import { AccessibleIcon, IconInfoFill } from '@vtex/shoreline'

import * as S from './styles'

export const KeywordListTotal = ({
  total,
  limit
}: {
  total: number
  limit: number
}) => {
  const limitError = total > limit
  return (
    <S.TotalWrapper>
      <S.Total limitError={limitError}>
        <AccessibleIcon className="totalLimitErrorIcon" label="total">
          <IconInfoFill />
        </AccessibleIcon>
        <div>
          total:{' '}
          <S.TotalValue limitError={limitError}>{total || 0}</S.TotalValue> /{' '}
          {limit}
        </div>
      </S.Total>
    </S.TotalWrapper>
  )
}
